import React from 'react';

interface HomeIconProps {
  width?: number;
  height?: number;
  color?: string;
  strokeColor?: string;
  className?: string;
}

const HomeIcon: React.FC<HomeIconProps> = ({
  width = 21,
  height = 20,
  color = '#686C71',
  strokeColor = 'black',
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35991 18.7283V12.3753H11.9599V18.7283H16.4599V10.2577H19.1599L10.1599 0.728271L1.15991 10.2577H3.85991V18.7283H8.35991Z"
        fill={color}
        stroke={strokeColor}
      />
    </svg>
  );
};

export default HomeIcon;
